import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const shiftLogRequest = createRequest(constants.shiftLog);
export const shiftLogSuccess = createSuccess(constants.shiftLog);
export const shiftLogFailure = createFailure(constants.shiftLog);

export const requestShiftLog = shiftLogRequest;
